export const enum DepositMethod {
  Deposit = 'deposit',
  PhoneCard = 'phone_card',
  QRPay = 'qrpay',
  Ewallet = 'ewallet',
  Crypto = 'crypto',
}

export const enum WithdrawMethod {
  Withdraw = 'withdraw',
  PhoneCard = 'phone_card',
  QRPay = 'QRPay',
  Banking = 'banking',
  Crypto = 'crypto',
}


export const enum DataFormRegister {
  Username = 'username',
  Fullname = 'fullname'
}
